import request from "@/utils/request";
import { getUserProfile } from "@/utils/auth";

// 只缓存当前页面内结果不确定的目标视频提交；成功后的主动重新生成使用新 ID。
const pendingVideoSubmissions = new Map();
const stablePayload = value => {
  if (Array.isArray(value)) return value.map(stablePayload);
  if (value && typeof value === 'object') return Object.keys(value).sort().reduce((result, key) => {
    result[key] = stablePayload(value[key]);
    return result;
  }, {});
  return value;
};
const newVideoRequestId = () => {
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  return 'video-' + Array.from(bytes, value => value.toString(16).padStart(2, '0')).join('');
};
const submissionWasRejected = error => {
  const body = error?.response?.data;
  if (body?.data?.submissionRejected === false) return false;
  if (body?.data?.submissionRejected === true) return true;
  const code = Number(body?.code);
  if (Number.isFinite(code) && code !== 0 && ((code > 0 && code < 500 && code !== 408) || code >= 600)) return true;
  const status = Number(error?.response?.status);
  return status >= 400 && status < 500 && status !== 408;
};

export function getCreateModels(params) {
  return request({
    url: "/api/c/create/models",
    method: "get",
    params,
  });
}

export function submitVideoGenerationRequest(url, data, options = {}) {
  const config = {
    url,
    method: "post",
    data,
    timeout: options.timeout || 3 * 60 * 1000,
    silentError: true, // 由调用方（failNotify）统一处理错误展示
  };
  if (data?.requestId) return request(config);

  const snapshot = JSON.parse(JSON.stringify(data));
  delete snapshot.requestId;
  const key = JSON.stringify([getUserProfile()?.id || '', url, stablePayload(snapshot)]);
  let entry = pendingVideoSubmissions.get(key);
  if (!entry) {
    entry = { payload: { ...snapshot, requestId: newVideoRequestId() }, promise: null };
    pendingVideoSubmissions.set(key, entry);
  }
  if (entry.promise) return entry.promise;
  entry.promise = request({ ...config, data: entry.payload }).then(response => {
    if (pendingVideoSubmissions.get(key) === entry) pendingVideoSubmissions.delete(key);
    return response;
  }, error => {
    if (submissionWasRejected(error) && pendingVideoSubmissions.get(key) === entry) pendingVideoSubmissions.delete(key);
    throw error;
  }).finally(() => { entry.promise = null; });
  return entry.promise;
}

export function createGenerateTask(data, options = {}) {
  if (Array.isArray(data?.targetSceneIds) && data.targetSceneIds.length && (!data.type || data.type === 'video')) {
    return submitVideoGenerationRequest('/api/c/create/tasks', data, options);
  }
  return request({ url: '/api/c/create/tasks', method: 'post', data, timeout: options.timeout || 3 * 60 * 1000, silentError: true });
}

export function getGenerateTask(taskId, options = {}) {
  return request({
    url: `/api/c/create/tasks/${encodeURIComponent(taskId)}`,
    method: "get",
    ...(options.baseURL ? { baseURL: options.baseURL } : {}),
    ...(options.timeout ? { timeout: options.timeout } : {}),
    silentError: !!options.silentError,
  });
}
